module.exports = __webpack_public_path__ + "img/b-sss-2@2x.c30035bc.png";